import {AppSessionStorageItemDto, AppSessionStorageKeysEnum, AppSessionStorageUserItemDto} from 'types/global';

export const AppSessionStorage = {
    getItem: <T extends AppSessionStorageKeysEnum = AppSessionStorageKeysEnum>(
        key: T,
    ): AppSessionStorageUserItemDto | null => {
        let value = null;

        if (localStorage.getItem(key)) {
            value = localStorage.getItem(key);
        }

        if (value) {
            return JSON.parse(value);
        }

        return null;
    },
    setItem: (item: AppSessionStorageItemDto) => {
        localStorage.setItem(item.type, JSON.stringify(item.data));
    },
    removeItem: (key: AppSessionStorageKeysEnum) => {
        localStorage.removeItem(key);
    },
    clear: () => localStorage.clear(),
};

const caches = {
    locale: AppSessionStorage,
};

export default caches;
